import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import PsychometricService from '../../services/PsychometricService';
import GeneralService from '../../services/GeneralService';
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';

const PsychometricIndividualSignUp = props => {
    // contexts
    const { theme, fontFamily, fontSize, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [individual, setIndividual] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        confirmPassword: "",
       
    });
    const [dateBeforeYears, setDateBeforeYears] = useState(moment());
    const [minimumAge, setMinimumAge] = useState(0);
    const [message, setMessage] = useState({ msgBody: '', msgError: false });
    const [isLoading, setIsLoading] = useState(false);
    let timerID = useRef(null);

    const history = useHistory(); // Initialize useHistory for navigation



    useEffect(() => {
        window.scrollTo(0, 0);
    }, [message]);

    // Utility functions
    // reset form 
    const resetForm = () => {
        try {
            setIndividual({
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                password: "",
                confirmPassword:"",
          
            });
        } catch (err) {
            Alert.error("Some error occurred, please try again later or report to the support team.");
            GeneralService.logError('at Individual SignUp resetForm', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setIndividual({ ...individual, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occurred, please try again later or report to the support team.");
            GeneralService.logError('at individual SignUp handleChange', 'Error in try catch block', err.stack);
        }
    }

    // Add this helper function to validate password
    const isPasswordValid = (password) => {
        const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{6,}$/;
        return passwordRegex.test(password);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Password validation checks
            if (!isPasswordValid(individual.password)) {
                setMessage({
                    msgBody: "Password must have at least 6 characters with one lowercase letter, one uppercase letter, and one number",
                    msgError: true
                });
                return;
            }

            // Check if passwords match
            if (individual.password !== individual.confirmPassword) {
                setMessage({
                    msgBody: "Passwords don't match",
                    msgError: true
                });
                return;
            }


           
            await PsychometricService.signUpIndividual(
                individual.firstName,
                individual.lastName,
                individual.email,
                individual.mobile,
                individual.password
            );

        
            resetForm();
            setMessage({
                msgBody: "Sign-up successful! Please check your email to verify your account before signing in.",
                msgError: false
            });

            // Pass the verification message through navigation state
            history.push({
                pathname: '/psychometricManagementPortal',
                state: { verificationMessage: "Please check your email to verify your account before signing in." }
            });
            
        } catch (err) {
            console.log("Error received:", err);
            
            let errorMessage = "Sign-up failed. Please try again.";
            
            // Check if the error indicates an existing email and show a more user-friendly message
            if (err.message?.msgBody && err.message.msgBody.toLowerCase().includes('already registered')) {
                errorMessage = "User already exists";
            } else if (err.message?.msgBody) {
                errorMessage = err.message.msgBody;
            }
            
            setMessage({
                msgBody: errorMessage,
                msgError: true
            });
        }
    };

  
    return (
        <div>
            <ErrorBoundary errorAt="At Individual SignUp GeneralNavbar">
                <PsychometricTestMainNavbar history={props.history} />
            </ErrorBoundary>
            <div className="col-md-6 py-5 offset-md-3">
                <div className="p-3" style={theme.form}>
                    <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        <h2 id="sign-up-heading" style={theme.heading}>Individual Sign Up</h2>
                        <br />

                        <ErrorBoundary errorAt="At Individual SignUp Message">
                            {message.msgBody ? <Message message={message} /> : null}
                        </ErrorBoundary>

                        <ErrorBoundary errorAt="At individual SignUp FormFields">
                            {/* First Name */}
                            <label htmlFor="firstName" style={theme.formBodyText}>First Name</label>
                            <input type="text" id="form-input-firstName" name="firstName" value={individual.firstName} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />
                            {/* Last Name */}
                            <label htmlFor="lastName" style={theme.formBodyText}>Last Name</label>
                            <input type="text" id="form-input-lastName" name="lastName" value={individual.lastName} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Email */}
                            <label htmlFor="email" style={theme.formBodyText}>Email</label>
                            <input type="email" id="form-input-email" name="email" value={individual.email} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Mobile */}
                            <label htmlFor="mobile" style={theme.formBodyText}>Mobile</label>
                            <input type="tel" id="form-input-mobile" name="mobile" value={individual.mobile} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                        
                            {/* Password */}
                            <label htmlFor="password" style={theme.formBodyText}>Password</label>
                            <input type="password" id="form-input-password" name="password" value={individual.password} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Confirm Password */}
                            <label htmlFor="confirmPassword" style={theme.formBodyText}>Confirm Password</label>
                            <input type="password" id="form-input-confirmPassword" name="confirmPassword" value={individual.confirmPassword} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />
                        </ErrorBoundary>

                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*Password must have at least 6 characters with one alphabet, one digit and one uppercase</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*After sign up, a verification email will be sent to your email address</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*By clicking on Sign Up button below, you agree to our <Link to='/termsconditions'><u>Terms &#38; Conditions</u></Link>, <Link to='/privacypolicy'><u>Privacy Policy</u></Link> and <Link to='/cookiepolicy'><u>Cookie Policy</u></Link></p>
                        <br />
                        <div className="row">
                            <button type="submit" className="btn btn-primary btn-lg mx-auto" style={theme.button}>Sign Up</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PsychometricIndividualSignUp;
